import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface IDownloadAppIconProps extends ISvgIconProps {

}

export class DownloadAppIcon extends React.Component<IDownloadAppIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="currentColor">
                    <path d="M17.104 17.943H7.198a1.813 1.813 0 0 1 -1.81 -1.81V13.624a0.6 0.6 0 0 1 1.2 0v2.508a0.611 0.611 0 0 0 0.61 0.61H17.104a0.611 0.611 0 0 0 0.61 -0.61V13.624a0.6 0.6 0 0 1 1.2 0v2.508a1.813 1.813 0 0 1 -1.81 1.811Z"/>
                    <path d="M12.152 13.418a0.6 0.6 0 0 1 -0.6 -0.6V6.022a0.6 0.6 0 0 1 0.6 -0.6 0.6 0.6 0 0 1 0.6 0.6v6.795a0.6 0.6 0 0 1 -0.6 0.6Z"/>
                    <path d="M12.15 14.561a0.598 0.598 0 0 1 -0.419 -0.17l-2.758 -2.694a0.6 0.6 0 1 1 0.838 -0.859l2.34 2.285 2.34 -2.284a0.6 0.6 0 0 1 0.838 0.858l-2.759 2.694a0.598 0.598 0 0 1 -0.419 0.17Z"/>
                </g>
            </SvgIcon>
        );
    }
}
